// extracted by mini-css-extract-plugin
module.exports = {"chip-filter":"chip-filters_chip-filter__yW9CI","chip-filter--active":"chip-filters_chip-filter--active__ZUvW5"};